module.exports = __webpack_public_path__ + "img/next_active.7a150c19.svg";